import React, { Component } from 'react';
import { Spinner } from '../components/Spinner';

export class LoadingPage extends Component {

    render() {
        return <Spinner/>;
    }
}
